import module from './module.js'
import './config.js'
import './run.js'
// Components
import './components/admin/component.js'
import './components/admin/welcome/component.js'
import './components/app/component.js'
import './components/app/login/component.js'
import './components/app/logout/component.js'
import './components/app/notsupported/component.js'
import './components/app/sync/components.js'
import './components/fan/admin/about/component.js'
import './components/fan/admin/about/politicas/component.js'
import './components/fan/admin/about/terminos/component.js'
import './components/fanconsultores/admin/component.js'
import './components/fanconsultores/admin/app/error/component.js'
import './components/fanconsultores/admin/app/toolbar/components.js'
import './components/fanconsultores/admin/auth/component.js'
import './components/fanconsultores/admin/dashboard/component.js'
import './components/fanconsultores/admin/dashboard/contabilidad/component.js'
import './components/fanconsultores/admin/dashboard/facturacion/component.js'
import './components/fanconsultores/admin/dashboard/finanzas/component.js'
import './components/fanconsultores/admin/dashboard/frontoffice/component.js'
import './components/fanconsultores/admin/dashboard/nominas/component.js'
import './components/fanconsultores/admin/dashboard/notaria/component.js'
import './components/fanconsultores/admin/dashboard/recursoshumanos/component.js'
import './components/fanconsultores/admin/dashboard/viaticos/component.js'
import './components/fanconsultores/admin/sesion/component.js'
import './components/fanconsultores/admin/sesion/alarma/component.js'
import './components/fanconsultores/admin/status/component.js'
import './components/shared/logo/component.js'
// Routes
import './routes/about.js'
import './routes/admin.js'
import './routes/app.js'
import './routes/dashboard.js'
import './routes/about/politicas.js'
import './routes/about/terminos.js'
import './routes/admin/welcome.js'
import './routes/app/login.js'
import './routes/app/logout.js'
import './routes/app/notSupported.js'
import './routes/dashboard/contabilidad.js'
import './routes/dashboard/facturacion.js'
import './routes/dashboard/finanzas.js'
import './routes/dashboard/frontoffice.js'
import './routes/dashboard/nominas.js'
import './routes/dashboard/notaria.js'
import './routes/dashboard/recursoshumanos.js'
import './routes/dashboard/recursoshumanos/dictamen.js'
import './routes/dashboard/viaticos.js'
// Services
import './services/Admin/Dashboard.js'
import './services/Admin/Dashboard/Nominas.js'
import './services/Shared/Language/Loader.js'
import './services/Shared/Language/Storage.js'

export default module.name



// WEBPACK FOOTER //
// ./src/fanconsultores/index.js